import labels from './metricsLabels'
import rowTypeMap from './rowTypeMap'

export default {
    labels,
    rowTypeMap
}


// WEBPACK FOOTER //
// ./src/app/configuration/Hyundai/config/components/scorecard/MetricsLabels/index.js